import {Directive, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, Renderer2} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {LayoutState} from '@csgofast/core/state/layout';
import {Store} from '@ngxs/store';
import {LazyLoadImageDirective} from '../lazy-load-image/lazy-load-image.directive';

@Directive({
  selector: 'img[playerImage]',
})
export class PlayerImageDirective extends LazyLoadImageDirective implements OnChanges {
  @Input() public width = 330;
  @Input() public height = 192;
  @Input() public userId?: number;
  @Output() public clickOnUser: EventEmitter<number> = new EventEmitter();

  private dimensions: number | undefined;

  @HostListener('click', ['$event.target'])
  public openProfile(): void {
    if (this.userId) {
      this.clickOnUser.emit(this.userId);
    }
  }

  constructor(private elementRef: ElementRef, private render: Renderer2, private dialog: MatDialog, private store: Store) {
    super(elementRef,render);
    this.fallback = `//d2lomvz2jrw9ac.cloudfront.net/common/fallback/${this.store.selectSnapshot(LayoutState.theme)}.png`;
    this.elementRef.nativeElement.onError = this.onImageError();
  }

  public override ngOnChanges(): void {
    if (this.src) {
      this.src = this.computeUserAvatar(this.src);
    }

    super.ngOnChanges();
  }

  public computeUserAvatar(url: string): string {
    if (!url) return this.fallback;
    this.dimensions = this.computeComponentDimensions();
    if (url.startsWith('data:') || url.startsWith('http') || url.startsWith('//')) {
      if ((url || '').startsWith('https://din8r827idtuo.cloudfront.net/')) {
        const [source, ...query] = url.split('?');
        query.push(`width=${this.dimensions}`);
        query.push(`height=${this.dimensions}`);
        // ToDo: move it out
        return source.replace('din8r827idtuo.cloudfront.net', 'de4khei8i4ut2.cloudfront.net') + `?${query.join('&')}`;
      }
      if (url.startsWith('https://api.adorable.io/avatars/')) {
        const avatar = url.split('/');
        const path = avatar[avatar.length - 1];
        return `https://api.adorable.io/avatars/${this.dimensions}/${path}`;
      }
      return url;
    }

    return `https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/${url}_full.jpg`;
  }

  public computeComponentDimensions(): number {
    const host = getComputedStyle(this.elementRef.nativeElement);
    const size = host.getPropertyValue('--size');
    const [, dimensions, type] = size.split(/([0-9]+)/);
    const width = 120;
    const dimensionsNumber = isNaN(Number(dimensions)) ? width : Number(dimensions);
    if (type === 'rem') {
      const calculated = dimensionsNumber * 16;
      return calculated < width ? width : calculated;
    }
    return Math.max(width, dimensionsNumber);
  }

  public onImageError(): void {
    this.src = this.fallback;
  }
}
